import { render, staticRenderFns } from "./ProspectPropositionCreate.vue?vue&type=template&id=c13913ee"
import script from "./ProspectPropositionCreate.vue?vue&type=script&lang=ts"
export * from "./ProspectPropositionCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports